import { DialogAlertTemplates } from "../types";

type GetTemplatesPayload = {
  setOpen?: (data: boolean) => void;
};
type GetTemplatesFunc = (payload: GetTemplatesPayload) => DialogAlertTemplates;

export const getDialogTemplates: GetTemplatesFunc = ({ setOpen = () => {} }) => ({
  "success.saved": {
    variant: "success",
    title: "success.saved.title",
    description: "success.saved.description",
    cancelText: "close"
  },
  "success.deleted": {
    variant: "success",
    title: "success.deleted.title",
    description: "success.deleted.description",
    cancelText: "close"
  },
  "success.removed": {
    variant: "success",
    title: "success.removed.title",
    description: "success.removed.description",
    cancelText: "close"
  },
  "error.api_db_error": {
    variant: "error",
    title: "error.api_db_error.title",
    description: "error.api_db_error.description",
    cancelText: "close"
  },
  "error.permission_denied": {
    variant: "error",
    title: "error.permission_denied.title",
    description: "error.permission_denied.description",
    confirmText: "error.permission_denied.confirm_text",
    showCancel: false,
    onConfirm: () => setOpen(false)
  },
  "error.session_expired": {
    variant: "error",
    title: "error.session_expired.title",
    description: "error.session_expired.description",
    confirmText: "error.session_expired.confirm_text",
    showCancel: false
  },
  "error.user_not_found": {
    variant: "error",
    title: "error.user_not_found.title",
    description: "error.user_not_found.description",
    confirmText: "error.user_not_found.confirm_text",
    showCancel: false
  },
  "error.data_not_found": {
    variant: "error",
    title: "error.data_not_found.title",
    description: "error.data_not_found.description",
    cancelText: "close"
  },
  "error.data_restrict_editing": {
    variant: "error",
    title: "error.data_restrict_editing.title",
    description: "error.data_restrict_editing.description",
    cancelText: "close"
  },
  "error.network_timeout_error": {
    variant: "error",
    title: "error.network_timeout_error.title",
    description: "error.network_timeout_error.description",
    cancelText: "close"
  },
  "error.queue_full": {
    variant: "error",
    title: "error.queue_full.title",
    description: "error.queue_full.description",
    cancelText: "close"
  },
  "error.invalid_data_format": {
    variant: "error",
    title: "error.invalid_data_format.title",
    description: "error.invalid_data_format.description",
    cancelText: "close"
  },
  "error.data_linked_to_system_data": {
    variant: "error",
    title: "error.data_linked_to_system_data.title",
    description: "error.data_linked_to_system_data.description",
    cancelText: "close"
  },
  "error.pending_workflow_conflict": {
    variant: "error",
    title: "error.pending_workflow_conflict.title",
    description: "error.pending_workflow_conflict.description",
    cancelText: "close"
  },
  "error.invalid_incomplete_data": {
    variant: "error",
    title: "error.invalid_incomplete_data.title",
    description: "error.invalid_incomplete_data.description",
    cancelText: "close"
  },
  "error.client_side_error": {
    variant: "error",
    title: "error.client_side_error.title",
    description: "error.client_side_error.description",
    cancelText: "close"
  },
  "error.system_limitation": {
    variant: "error",
    title: "error.system_limitation.title",
    description: "error.system_limitation.description",
    cancelText: "close"
  },
  "error.timeout": {
    variant: "error",
    title: "error.timeout.title",
    description: "error.timeout.description",
    cancelText: "close"
  },
  "error.duplicate_data": {
    variant: "error",
    title: "error.duplicate_data.title",
    description: "error.duplicate_data.description",
    cancelText: "close"
  },
  "error.something_went_wrong": {
    variant: "error",
    title: "error.something_went_wrong.title",
    description: "error.something_went_wrong.description",
    cancelText: "close"
  },
  "confirm.delete": {
    variant: "confirm",
    title: "confirm.delete.title",
    description: "confirm.delete.description",
    confirmText: "confirm.delete.confirm_text"
  },
  "confirm.inactive": {
    variant: "confirm",
    title: "confirm.inactive.title",
    description: "confirm.inactive.description",
    confirmText: "confirm.inactive.confirm_text"
  },
  "confirm.active": {
    variant: "confirm-green",
    title: "confirm.active.title",
    description: "confirm.active.description",
    confirmText: "confirm.active.confirm_text"
  },
  "confirm.leave_page": {
    variant: "confirm",
    title: "confirm.leave_page.title",
    description: "confirm.leave_page.description",
    confirmText: "confirm.leave_page.confirm_text"
  },
  "confirm.remove": {
    variant: "confirm",
    title: "confirm.remove.title",
    description: "confirm.remove.description",
    confirmText: "confirm.remove.confirm_text"
  },
  "confirm.logout": {
    variant: "confirm",
    title: "confirm.logout.title",
    description: "confirm.logout.description",
    confirmText: "confirm.logout.confirm_text"
  }
});
